import api from '@/api/comments'
import errors from '@/api/errors'

const state = {
  // internal
  query: {},
  // view
  count: 0,
  comments: []
}

const getters = {
  // view
  count: state => state.count,
  comments: state => state.comments,
  firstComment: state => state.comments[0]
}

const mutations = {
  updateQuery: (state, newQuery) => {
    Object.assign(state.query, newQuery)
  },
  setComments: (state, data) => {
    state.count = data.count
    state.comments = data.lists
  },
  addComments: (state, data) => {
    state.comments.push(...data.lists)
  },
  deleteComment: (state, args) => {
    const newComments = state.comments.filter((comment) => {
      return comment.comment_id !== args.commentId
    })
    state.comments = newComments
    --state.count
  },
  setComment: (state, data) => {
    const newLists = state.comments.concat(data)
    state.comments = newLists
  }
}

const actions = {
  // 初期表示
  getComments: ({ dispatch, commit }, args) => {
    dispatch('commons/setLoadingMore', { isLoading: true }, { root: true })
    dispatch('commons/clearGlobalError', {}, { root: true })
    const params = Object.assign({}, state.query, args)
    return api.getReviewComment(params).then(data => {
      commit('setComments', data)
      commit('updateQuery', params)
    })
    .catch(error => {
      dispatch('commons/setGlobalError', error, { root: true })
    })
    .then(() => {
      dispatch('commons/setLoadingMore', { isLoading: false }, { root: true })
    })
  },
  // もっと見る
  getMoreComments: ({ dispatch, commit }, args) => {
    dispatch('commons/setLoadingMore', { isLoading: true }, { root: true })
    dispatch('commons/clearGlobalError', {}, { root: true })
    const params = Object.assign({}, state.query, args)
    return api.getReviewComment(params).then(data => {
      commit('addComments', data)
      commit('updateQuery', params)
      dispatch('commons/setLoadingMore', { isLoading: false }, { root: true })
    })
    .catch(error => {
      dispatch('commons/setLoadingMore', { isLoading: false }, { root: true })
      if (error instanceof errors.AuthenticationError) {
        dispatch('commons/setGlobalError', error, { root: true })
      } else {
        return Promise.reject(Error('問題が発生したため処理を継続することができませんでした。'))
      }
    })
  },
  registComment: ({ dispatch, commit }, args) => {
    dispatch('commons/setLoadingPost', { isLoading: true }, { root: true })
    dispatch('commons/clearGlobalError', {}, { root: true })
    const params = {
      reviewId: args.reviewId,
      description: args.description
    }
    return api.registReviewComment(params).then(data => {
      dispatch('commons/setLoadingPost', { isLoading: false }, { root: true })
      return data
    })
    .catch(error => {
      dispatch('commons/setLoadingPost', { isLoading: false }, { root: true })
      if (error instanceof errors.AuthenticationError) {
        dispatch('commons/setGlobalError', error, { root: true })
      } else if (error instanceof errors.InputValidationError) {
        return Promise.reject(Error(error.message))
      } else {
        return Promise.reject(Error('問題が発生したため処理を継続することができませんでした。'))
      }
    })
  },
  deleteComment: ({ dispatch, commit }, args) => {
    dispatch('commons/setLoadingPost', { isLoading: true }, { root: true })
    dispatch('commons/clearGlobalError', {}, { root: true })
    const params = {
      reviewId: args.reviewId,
      commentId: args.commentId
    }
    return api.deleteReviewComment(params).then(result => {
      commit('deleteComment', args)
      dispatch('commons/setLoadingPost', { isLoading: false }, { root: true })
      return result
    })
    .catch(error => {
      dispatch('commons/setLoadingPost', { isLoading: false }, { root: true })
      if (error instanceof errors.AuthenticationError) {
        dispatch('commons/setGlobalError', error, { root: true })
      } else {
        return Promise.reject(Error('問題が発生したため処理を継続することができませんでした。'))
      }
    })
  },
  /**
   * コメント取得 (ID指定)
   */
  getCommentById: ({ dispatch, commit }, args) => {
    dispatch('commons/clearGlobalError', {}, { root: true })
    const params = Object.assign({}, state.query, {
      reviewId: args.reviewId,
      commentId: args.commentId
    })
    return api.getCommentById(params).then(data => {
      commit('setComment', data)
    }).catch(error => {
      dispatch('commons/setGlobalError', error, { root: true })
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/comments.js